import { useCallback } from 'react';
import { useSendOnCopilotChannel } from '../channel/hooks/useSendOnCopilotChannel';
export const useSendMessageFromAppToCopilot = () => {
  const sendCopilotMessageOnChannel = useSendOnCopilotChannel('SEND_MESSAGE');
  return useCallback(({
    messageText = '',
    messageMetaInfo,
    customAssistantData
  }) => {
    if (messageText) {
      sendCopilotMessageOnChannel({
        messageText,
        messageMetaInfo,
        customAssistantData
      });
    }
  }, [sendCopilotMessageOnChannel]);
};
export const useSendCollaborationPluginContext = () => {
  const sendCopilotMessageOnChannel = useSendOnCopilotChannel('COLLABORATE_COPILOT_SET_CONTEXT');
  return useCallback(({
    plugin,
    extraIntentProperties
  }) => {
    sendCopilotMessageOnChannel({
      plugin,
      extraIntentProperties
    });
  }, [sendCopilotMessageOnChannel]);
};
export const useSendCollaborationAction = () => {
  const sendCopilotActionOnChannel = useSendOnCopilotChannel('SEND_ACTION');
  return useCallback(({
    messageAction,
    messageMetaInfo,
    customAssistantData
  }) => {
    sendCopilotActionOnChannel({
      messageAction,
      messageMetaInfo,
      customAssistantData
    });
  }, [sendCopilotActionOnChannel]);
};
export const useAskUserForMoreInfo = () => {
  const sendCopilotActionOnChannel = useSendOnCopilotChannel('PROMPT_USER_FOR_MORE_INFO');
  return useCallback(({
    messageAction,
    messageMetaInfo,
    promptData
  }) => {
    sendCopilotActionOnChannel({
      messageAction,
      messageMetaInfo,
      promptData
    });
  }, [sendCopilotActionOnChannel]);
};